import { useMemo } from 'react'
import { Tooltip } from 'react-tooltip'
import { v4 } from 'uuid'

const TruncatedText = ({ text = "", maxLength = 20, style = {}, className = "" }) => {
    const isTruncated = text?.length > maxLength;
    const tooltipId = useMemo(() => `tooltip-${v4()}`, [])
    return (
        <>
            {
                !isTruncated &&
                <div className={className} style={{ ...style }}>{text}</div>
            }
            {
                isTruncated &&
                <>
                    <div data-tooltip-id={tooltipId} data-tooltip-content={text} className={className} style={{ ...style }}>{text.slice(0, maxLength) + '...'}</div>
                    <Tooltip id={tooltipId}
                        positionStrategy="absolute"
                        multiline={true}
                        style={{
                            whiteSpace: "normal",
                            maxWidth: "512px",
                            zIndex: 9999,
                            borderRadius: "16px",
                            color: "#000",
                            background: '#fff',
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                        }}
                    >
                        <div className={className} style={{
                            ...style,

                        }}>{text}</div>
                    </Tooltip>
                </>
            }
        </>
    );
};

export default TruncatedText;
